import { Option } from './SelectActivityTypes';

export const sortByActivityTypeName = (a: Option, b: Option) =>
  a.label.localeCompare(b.label, 'en', { sensitivity: 'base' });
